import { useId } from "react";

import styles from "./styles.module.css";

export default function TextField({
  id,
  label,
  placeholder,
  onChange,
  value,
  type,
  errors,
  ...inputProps
}) {
  const inputId = id ?? `tf-${useId()}`;

  return (
    <div className={styles.formElement}>
      {label && (
        <label htmlFor={inputId}>{label}</label>
      )}
      <div>
        <input
          type={type ?? "text"}
          className={styles.input}
          placeholder={placeholder}
          id={inputId}
          {...inputProps}
        />
        {errors && (
          <ul className="errorsContainer">
            {errors.map(errorMessage => (
              <li>{errorMessage}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
